export var fontSizes = {
  bodyL: {
    xs: '1rem',
    sm: '1.125rem',
    md: '1.125rem',
    lg: '1.125rem',
    xl: '1.25rem'
  },
  bodyM: {
    xs: '0.875rem',
    sm: '1rem',
    md: '1rem',
    lg: '1rem',
    xl: '1.125rem'
  },
  bodyS: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '0.875rem',
    lg: '0.875rem',
    xl: '1rem'
  },
  displayL: {
    xs: '2.75rem',
    sm: '3.25rem',
    md: '3.75rem',
    lg: '4rem',
    xl: '4.125rem'
  },
  displayM: {
    xs: '2.5rem',
    sm: '3.5rem',
    md: '3.5rem',
    lg: '3.5rem',
    xl: '3.625rem'
  },
  displayS: {
    xs: '2.25rem',
    sm: '2.5rem',
    md: '2.75rem',
    lg: '3rem',
    xl: '3.125rem'
  },
  headlineL: {
    xs: '2rem',
    sm: '2.125rem',
    md: '2.25rem',
    lg: '2.5rem',
    xl: '2.625rem'
  },
  headlineM: {
    xs: '1.75rem',
    sm: '1.875rem',
    md: '2rem',
    lg: '2.125rem',
    xl: '2.25rem'
  },
  headlineS: {
    xs: '1.5rem',
    sm: '1.625rem',
    md: '1.75rem',
    lg: '1.875rem',
    xl: '2rem'
  },
  labelL: {
    xs: '0.875rem',
    sm: '1rem',
    md: '1rem',
    lg: '1rem',
    xl: '1.125rem'
  },
  labelM: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '0.875rem',
    lg: '0.875rem',
    xl: '1rem'
  },
  labelS: {
    xs: '0.625rem',
    sm: '0.75rem',
    md: '0.75rem',
    lg: '0.75rem',
    xl: '0.875rem'
  },
  titleL: {
    xs: '1.25rem',
    sm: '1.375rem',
    md: '1.5rem',
    lg: '1.5rem',
    xl: '1.625rem'
  },
  titleM: {
    xs: '1.125rem',
    sm: '1.25rem',
    md: '1.25rem',
    lg: '1.25rem',
    xl: '1.375rem'
  },
  titleS: {
    xs: '1rem',
    sm: '1.125rem',
    md: '1.125rem',
    lg: '1.125rem',
    xl: '1.25rem'
  }
};